import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CargoReferenciaService } from '@core/services/cargoreferencia.service';
import { NotificationService } from '@core/services/notification.service';

@Component({
  selector: 'app-cargo-form',
  templateUrl: './cargo-form.component.html',
  styleUrls: ['./cargo-form.component.scss']
})
export class CargoFormComponent implements OnInit, OnChanges {

  @Input() cargo: any;
  @Input() dataSet: any;
  @Output() dadosCargoEmit = new EventEmitter<any>();

  adicionarCargoForm!: FormGroup;
  inserir: boolean = true;

  cargoReferenciaList: any;

  constructor(
    private fb: FormBuilder,
    private cargoReferenciaService: CargoReferenciaService,
    private notificationService: NotificationService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.cargo) {
      this.inserir = false;
      this.adicionarCargoForm.patchValue(this.cargo);
    }
  }

  ngOnInit(): void {
    this.buildForm();
    this.cargoReferenciaService.listar().subscribe((cargos: any) =>
      this.cargoReferenciaList = cargos);
  }

  buildForm(): void {
    this.adicionarCargoForm = this.fb.group({
      id: [''],
      idCargoReferencia: ['', Validators.required],
       nivelHierarquico: ['']
    })
  }


salvar() {
  if (this.adicionarCargoForm.invalid || !this.cargoReferenciaControl?.value) {
    this.notificationService.error('Erro', 'Preencha todos os campos obrigatórios');
    this.adicionarCargoForm.markAllAsTouched();
    return;
  }

  const raw = this.adicionarCargoForm.getRawValue();

  const objEnvio = {
    ...raw,
    idCargoReferencia: raw.idCargoReferencia?.id, // salva só o ID
    nomeCargoReferencia: raw.idCargoReferencia?.nomeCargoReferencia
  };

  this.dadosCargoEmit.emit(objEnvio);
  this.reset();
}



  reset() {
    this.inserir = true;
    this.cargoReferenciaControl?.enable();

    Object.keys(this.adicionarCargoForm.controls).forEach(key => {
      const control = this.adicionarCargoForm.get(key);
      if (control) {
        control.clearValidators();
        control.updateValueAndValidity({ emitEvent: false });
      }
    });

    this.adicionarCargoForm.reset();

    Object.keys(this.adicionarCargoForm.controls).forEach(key => {
      const control = this.adicionarCargoForm.get(key);
      if (control) {
        switch (key) {
          case 'nomeCargoReferencia':
          case 'cargoSubordinado':
                        // control.setValidators(Validators.required);
            break;
          default:
            break;
        }
        control.updateValueAndValidity({ emitEvent: false });
      }
    });
  }

  compareFn(a: any, b: any): boolean {
    if (typeof a === 'boolean' && (typeof b === 'string' || typeof b === 'boolean')) {
      b = b === 'true';
    }

    if (a?.id !== undefined && b?.id !== undefined) {
      return a.id === b.id;
    }
    else if (a?.codigo !== undefined && b?.codigo !== undefined) {
      return a.codigo === b.codigo;
    }
    else {
      return a === b;
    }
  }

  get cargoReferenciaControl() {
    return this.adicionarCargoForm.get('idCargoReferencia');
  }

}
